import { Button, Modal, Select, Upload } from "antd";
import { MdRemoveCircleOutline } from "react-icons/md";
import { styled } from "styled-components";
import { colors } from "../../../theme/colors";
import FormItem from "antd/es/form/FormItem";
import { Card } from "../../../components/ui/card/card.component";
import { UploadOutlined } from "@ant-design/icons";
import { Column } from "../../../components/ui/grid/column.component";
import { Spacer } from "../../../components/ui/spacer/spacer.component";
import { useState } from "react";
import { masterToOptions } from "../../../utils/functions/misc/masterToOptions";
import { useAtomValue } from "jotai";
import { masterAtom } from "../../../atoms/masters.atom";
import { FileUpload } from "../../../components/ui/file-upload/file-upload.component";

export const Subtitle = ({
  language,
  file,
  onChange,
  onRemove,
  disabled = false,
  isDeletable = true,
  fileUploadVariant = "button",
}: {
  language: string | undefined;
  file: File | null;
  onChange: (
    newSubtitle: Partial<{ language: string; file: File | null }>
  ) => void;
  onRemove: () => void;
  disabled?: boolean;
  isDeletable?: boolean;
  fileUploadVariant?: "button" | "dropzone";
}) => {
  const master = useAtomValue(masterAtom);

  return (
    <Main $disabled={disabled}>
      <RemoveButton
        $disabled={disabled || !isDeletable}
        onClick={() => (disabled || !isDeletable ? null : onRemove())}
      />
      <Column style={{ alignItems: "flex-start" }}>
        <Select
          options={masterToOptions("languages", master, [], true)}
          onSelect={(newLanguage) => onChange({ language: newLanguage })}
          placeholder="Select language"
          value={language}
          showSearch
        />
        <Spacer size={5} direction="bottom" />
        <FileUpload
          variant={fileUploadVariant}
          file={file instanceof File ? file : null}
          onChange={(file) => onChange({ file })}
          uploaded={!!file}
          accept=".srt"
        />
        {/* <Spacer size={5} direction="bottom" />
        <Upload onChange={(newFile) => onChange({ file: newFile.file })}>
          <Button icon={<UploadOutlined />}>Upload</Button>
        </Upload> */}
      </Column>
    </Main>
  );
};

const Main = styled(Card)<{
  $disabled: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 0.75rem;
  padding: 2rem 3rem;
  min-width: min(100%, 20rem);
  max-width: 100%;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;

const RemoveButton = styled(MdRemoveCircleOutline).attrs({
  size: 17,
  color: colors.error.hex,
})<{ $disabled: boolean }>`
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
`;

const Name = styled.h3<{ $disabled: boolean }>`
  font-size: 1.6rem;
  font-weight: 500;
  color: ${colors.primary.hex};
  border-bottom: 2px dashed ${colors.primary.hex};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
`;

const Year = styled.h4`
  font-size: 1.3rem;
  font-weight: 500;
  opacity: 0.7;
`;
